export const getAdditionalQueryParamsState = (currentState, payload) => ({
  ...currentState,
  refine: payload.refine || ""
});

export { default as getOneProductRedirectUrl } from "./getOneProductRedirectUrl";
